import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import Global from '../../../store/global-selectors';
import * as Actions from '../../../store/alerts/grid/alerts.grid.actions';

const DismissAlertButton = () => {
  const dispatch = useDispatch();
  const selectedAlertIds = useSelector(Global.selectAlertsGridgetSelectedAlertIds) || [];
  const isDisabled = selectedAlertIds.length === 0;

  const onDismissAlerts = useCallback(() => {
    dispatch(Actions.alertDismissalRequest());
  }, [dispatch]);

  return (
    <div>
      <Button disabled={isDisabled} onClick={() => onDismissAlerts()} theme='tertiary'>
        <FormattedMessage defaultMessage='Dismiss' description='alertHeader.dismiss' id='wylM6o' />
      </Button>
    </div>
  );
};

export default DismissAlertButton;
